import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const phoneNumber = '34644464599'; // Número con código de país de España
  const message = encodeURIComponent('¡Hola! Me gustaría obtener más información sobre las clases en MASTER-CLASS.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 group flex items-center justify-center"
      aria-label="Contactar por WhatsApp"
    >
      <FaWhatsapp size={32} />
      
      {/* Tooltip */}
      <span className="absolute left-full ml-3 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Contáctanos por WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
